export const DAYS = ['一', '二', '三', '四', '五', '六', '日'];
